import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Typography, TypographyType, TypographyVariant } from 'src/components-dummy/Typography';

export interface FormCardTitleProps {
  children: ReactNode | ReactNode[];
  className?: string;
  variant?: TypographyVariant;
}

export const FormCardTitle = ({
  children,
  className,
  variant = TypographyVariant.ExtraSmallBold,
}: FormCardTitleProps): JSX.Element => {
  return (
    <Typography
      className={classNames('syte-form-card-title', className)}
      type={TypographyType.Heading}
      variant={variant}
    >
      {children}
    </Typography>
  );
};
